"use strict";

/* eslint-disable @typescript-eslint/no-explicit-any */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSyncTransform = void 0;
var isSyncTransform = function isSyncTransform(transform) {
  return transform.length === 1;
};
exports.isSyncTransform = isSyncTransform;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiLi4vLi4vc3JjL3R5cGVzLnRzIl0sInNvdXJjZXNDb250ZW50IjpbbnVsbF0sIm1hcHBpbmdzIjoiOztBQUFBOzs7OztBQVlPLElBQU0sZUFBZSxHQUFHLFNBQWxCLGVBQWUsQ0FDeEIsU0FBcUMsRUFDQTtFQUNyQyxPQUFPLFNBQVMsQ0FBQyxNQUFNLEtBQUssQ0FBQztBQUNqQyxDQUFDO0FBSlksdUJBQWUiLCJpZ25vcmVMaXN0IjpbXX0=